import { PillarKey } from '../../../../../../api/theHive/redeProto/types';
import { PillarCard } from '../../components/PillarCard';
import { StateFeedback } from '../../components/StateFeedback';
import { PillarGrid } from './styles';
import useBsc from './useBsc';

export function Bsc(): JSX.Element {
  const { pillars, evolution, loading, error } = useBsc();

  const labels = evolution.map((point) => point.month);

  const sparklineFor = (key: PillarKey): (number | null)[] | undefined => {
    switch (key) {
      case 'growth':
        return evolution.map((point) => point.totalDemands);
      case 'experience':
        return evolution.map((point) => point.avgCsat);
      case 'result':
        return evolution.map((point) => point.slaPct);
      default:
        return undefined;
    }
  };

  return (
    <StateFeedback loading={loading} error={error} empty={pillars.length === 0}>
      <PillarGrid>
        {pillars.map((pillar) => {
          const data = sparklineFor(pillar.key);
          return (
            <PillarCard
              key={pillar.key}
              pillar={pillar}
              sparkline={data ? { labels, data } : undefined}
            />
          );
        })}
      </PillarGrid>
    </StateFeedback>
  );
}
